import React, { FunctionComponent } from "react";
import styles from "./styles.module.scss";

interface NewsletterTitleProps {
    title: string;
    style?: string;
    nested?: boolean;
}

const NewsletterTitle: FunctionComponent<NewsletterTitleProps> = ({ title, style, nested }) => {
    if (!style && nested) {
        return <h3 className={ styles.newsletter }>{ title }</h3>;
    }

    if (!style) {
        return <h2 className={ styles.newsletter }>{ title }</h2>;
    }

    const [ theme, variation ] = style.split("-");
    const [ titleA, titleB ] = splitTitle(title);

    let content;

    switch (variation) {
        case "full":
            content = <span className={ styles[theme] }>{ titleA } { titleB }</span>;
            break;
        case "reverse":
            content = <><span className={ styles[theme] }>{ titleA }</span> { titleB }</>;
            break;
        default:
            content = <>{ titleA }<span className={ styles[theme] }> { titleB }</span></>;
    }

    if (nested) {
        return <h3 className={ styles.newsletter }>{ content }</h3>;
    }

    return <h2 className={ styles.newsletter }>{ content }</h2>;
};

function splitTitle(title: string): [string, string] {
    const titleParts = title.split(" ");
    let titleA = "";
    let titleB = "";

    for (let i = 0; i < titleParts.length; ++i) {
        if ((i < (titleParts.length / 2))) {
            titleA += `${ titleParts[i] } `;
        } else {
            titleB += `${ titleParts[i] } `;
        }
    }

    return [
        titleA.trim(),
        titleB.trim()
    ];
}

export default NewsletterTitle;
